import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import ResetForm from './ResetForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";
import './reset.css';
import Logo from '../../../../../assets/img/Logo.png'

class Reset extends Component {
    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
    };

    componentDidMount(props) {
        this.state = { prueba: true };
    }

    render() {
        const { onSubmit, loader } = this.props;
        if (localStorage.getItem('token')) {
            return (<Redirect to="/" />);
        }
        return (
            <div className="blue-gradient-bg  align-self-center align-items-center justify-content-center ">
                <div className="login-wrapper col-lg-4 col-md-4 col-4  "> 
                    <div className="card card-login justify-content-center align-self-center">
                        
                        <img className="logo" src={Logo}></img>
                        <h5 className="text-center pv"><bold>RECUPERAR CONTRASEÑA</bold></h5>
                        <p className="text-center">
                            Ingresa tu correo electronico, se te enviara un correo
                            para poder restablecer tu contraseña
                        </p>
                        <LoadMask loading={loader} light >
                            <ResetForm onSubmit={onSubmit} />
                        </LoadMask>
                    </div>
                </div>
            </div>
        );
    }
}

export default Reset;
